export default {
  appName: 'Zen Protocol Dex',
  appNameShort: 'Dex',
  logoutMinutes: 15,
  uri: process.env.REACT_APP_URI || 'dex.zp.io',
  contractId: '00000000e15e60b4e8d9f2ae48772e3d0f23c953ef061ef01f93ab8c6200b853225942c4',
  nodeUrl: 'https://mainnet-nodes.zp.io',
  oracleUrl: {
    test: 'https://oracle-test.zp.io',
    main: 'https://oracle-main.zp.io',
  },
  oraclePk: {
    test: '0365772539ac7dac9afcdb8e4a446512a96ef5de868ec7995e2fbb2e6d604a0362',
    main: '020dc7cad106e9284be13576f5271c4f694da464076d2eb44fd5c74265316f70a3',
  },
  oracleCid: '00000000065ee39e9f6af7d6e185f5b72eace28cc48bba05969742f0f9066519f3452369',
  nodes: [
    {
      label: 'Mainnet | Remote Node | mainnet-nodes.zp.io',
      value: 'main https://mainnet-nodes.zp.io',
    },
    {
      label: 'Testnet | Remote Node | testnet-nodes.zp.io',
      value: 'test https://testnet-nodes.zp.io',
    },
  ],
  orderbookServer: {
    test: process.env.REACT_APP_ORDERBOOK_SERVER_TEST || 'http://localhost:5088',
    main: process.env.REACT_APP_ORDERBOOK_SERVER_MAIN || 'http://localhost:5089',
  },
  chain: 'main',
  zenJsVersion: process.env.REACT_APP_ZENJS_VERSION || '0.0.0',
  buildVersion: process.env.REACT_APP_BUILD_VERSION || '0.0.0',
  explorer: {
    main: process.env.REACT_APP_EXPLORER_MAIN || 'https://zp.io',
    test: process.env.REACT_APP_EXPLORER_TEST || 'https://testnet.zp.io',
  },
  contract: {
    main: process.env.REACT_APP_FP_CONTRACT_ID_MAIN,
    test: process.env.REACT_APP_FP_CONTRACT_ID_TEST,
  },
  contracts: process.env.REACT_APP_FP_CONTRACTS
    ? JSON.parse(process.env.REACT_APP_FP_CONTRACTS)
    : [],
  contractNamingUrl: process.env.REACT_APP_CONTRACT_NAMING_JSON,
  contractAssetUrl: {
    main: process.env.REACT_APP_ASSET_NAMING_JSON,
    test: process.env.REACT_APP_ASSET_NAMING_TEST_JSON,
  },
  errorReporting: {
    endpoint: process.env.REACT_APP_CONFIG_REPORT_ERRORS_ENDPOINT,
    token: process.env.REACT_APP_CONFIG_REPORT_ERRORS_TOKEN,
    attributes: {
      processType: 'web',
      NODE_ENV: process.env.NODE_ENV,
      zenJsVersion: process.env.REACT_APP_ZENJS_VERSION || 'unknown',
      buildVersion: process.env.REACT_APP_BUILD_VERSION || 'unknown',
      // override for anonymity
      referer: '',
      hostname: '',
    },
  },
};
